import React from 'react';
import { Text } from '@mantine/core';
import ListCheck from '@/components/ui/list/components/List.Check';
import type { TypeSelectionSide, TypeTableSelection } from '@/types/list/types.list.selection';

type Props<T> = {
    selection?: TypeTableSelection<T>;
    selectionAt?: TypeSelectionSide;
    children?: React.ReactNode;
};

function ListHead<T>({ selection, selectionAt = 'end', children }: Props<T>) {
    if (!selection && !children) return null;

    const check = selection ? (
        <div className="bd-list-check" data-at={selectionAt}>
            <ListCheck
                checked={selection.state === 'all'}
                indeterminate={selection.state === 'some'}
                label={selection.allLabel}
                onToggle={selection.toggleAll}
            />
        </div>
    ) : null;

    return (
        <div className="bd-list-head">
            {selectionAt === 'start' ? check : null}
            {children ? <div style={{ flex: 1, minWidth: 0 }}>{children}</div> : null}
            {selection ? (
                <Text size="xs" c="dimmed" fw={500} className={children ? 'bd-list-head-label' : undefined} style={{ flex: 1, textAlign: selectionAt === 'end' ? 'end' : undefined }}>
                    {selection.allLabel}
                </Text>
            ) : null}
            {selectionAt === 'end' ? check : null}
        </div>
    );
}

export default ListHead;
